import * as React from 'react'
import '../components/sections/Recruiting/styles.css'
// components
import Footer from '../components/layouts/Footer'
import RecruitingQuote from '../components/sections/Recruiting/components/RecruitingQuote'
import RecruitingHeader from '../components/sections/Recruiting/components/RecruitingHeader'
import PodRecruitingSection from '../components/sections/Recruiting/components/PodRecruitingSection'
import PodAutomaticallySection from '../components/sections/Recruiting/components/PodAutomaticallySection'
import PodImplementationSection from '../components/sections/Recruiting/components/PodImplementationSection'

const Recruiting = () => (
  <>
    <div className='snap-wrap'>
      <RecruitingHeader />
      <section className='recruiting-wrapper'>
        <PodRecruitingSection />
      </section>
      <section className='recruiting-wrapper'>
        <PodImplementationSection />
      </section>
      <section className='recruiting-wrapper'>
        <PodAutomaticallySection />
      </section>
      <section className='footer-snap-align recruiting-bottom-block'>
        <RecruitingQuote />
        <Footer theme='light' />
      </section>
    </div>
  </>
)

export default Recruiting
